<script lang="ts">
  import type { StatuteBill } from "../types";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import ContinueButton from "../../../components/workflow/ContinueButton.svelte";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import StatuteBillSummary from "../elements/StatuteBillSummary.svelte";
  import { formatGbp } from "../../../lib/formatting";
  import CloseButton from "../../../components/CloseButton.svelte";
  import Faqs from "../faqs/Faqs.svelte";

  let {
    payoutAmount,
    statuteBill,
  }: {
    payoutAmount: number;
    statuteBill: StatuteBill;
  } = $props();
</script>

<h2 class="ui-title">Confirm amount</h2>

<p>
  It’s time to receive payment from your <b>easyJet Data Breach</b> settlement! Please confirm the amount below. We’ll then collect your bank details and issue payment shortly thereafter.
</p>

<StatuteBillSummary {statuteBill} {payoutAmount} class="mb-4" />

<h3 class="ui-section-title mb-4">Statute bill</h3>

<a href={statuteBill.download} target="_blank" class="block">
  <div class="ui-content-options border rounded-lg mb-4 overflow-clip">
    <div class="flex items-center justify-center text-gray-400">
      <span class="loading loading-spinner loading-lg"></span>
    </div>
    <div class="relative">
      <img
        src={statuteBill.preview}
        alt="Statute bill"
        onload={(e) => ((e.currentTarget.parentElement!.previousElementSibling! as HTMLElement).style.visibility = "hidden")}
        class="aspect-[0.77] w-full" />
      <span class="text-gray-600 bg-gray-100 text-sm font-medium rounded-full py-0.5 px-2 absolute right-2 bottom-2">Page 1 of 3</span>
    </div>
  </div>
</a>

<DownloadLink label="Download statute bill" href={statuteBill.download} />

<label class="mt-4 flex items-start gap-2 text-sm font-medium text-gray-600 bg-gray-100 p-2 rounded-lg">
  <input type="checkbox" name="settlement_financial[offer_status]" value="accepted"  class="checkbox bg-white scroll-mb-60" required />
  I have viewed my statute bill and agree to the deductions from my compensation shown above. I acknowledge that I will
  be paid {formatGbp(payoutAmount)}.
</label>

<h3 class="ui-section-title">Have questions?</h3>
<Faqs />

<FooterButtons back={false}>
  <CloseButton />
  <ContinueButton label="Confirm & continue" name="settlement_financial[offer_status]" value="accepted" />
</FooterButtons>
